import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, X, Upload } from 'lucide-react';
import { getOrderDetail, openDispute } from '../../services/p2pService';
import { useToast } from '../../context/ToastContext';

const REASONS = ['Seller not responding','Payment not received','Wrong amount','Payment reversed','Other'];

export default function Dispute() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [order, setOrder] = useState<any>(null);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [evidence, setEvidence] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { getOrderDetail(id!).then(setOrder).catch(() => {}); }, [id]);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    files.forEach(f => {
      if (evidence.length >= 5) return;
      const r = new FileReader();
      r.onload = ev => setEvidence(prev => prev.length < 5 ? [...prev, ev.target?.result as string] : prev);
      r.readAsDataURL(f);
    });
  };

  const submit = async () => {
    if (!reason) { toast('Select a reason', 'error'); return; }
    if (!description.trim()) { toast('Provide a description', 'error'); return; }
    setLoading(true);
    try {
      await openDispute(id!, { reason, description, evidence });
      toast('Dispute submitted. Admin will review.', 'success');
      navigate(-1);
    } catch (e: any) { toast(e.message, 'error'); }
    setLoading(false);
  };

  return (
    <div className="p2p-page">
      <div className="p2p-header">
        <button className="p2p-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={20} />Open Dispute</button>
      </div>
      <div className="p2p-page-content" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
        {order && (
          <div className="p2p-card">
            <div className="p2p-row"><span className="p2p-row-label">Order #</span><span className="p2p-row-value">{order.orderNumber}</span></div>
            <div className="p2p-row"><span className="p2p-row-label">Amount</span><span className="p2p-row-value">{order.cryptoAmount?.toFixed(6)} {order.crypto}</span></div>
            <div className="p2p-row" style={{ border: 'none' }}><span className="p2p-row-label">Status</span><span className="p2p-row-value">{order.status}</span></div>
          </div>
        )}
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--p2p-text-primary)', marginBottom: 10 }}>Reason</div>
          {REASONS.map(r => (
            <label key={r} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', borderBottom: '1px solid var(--p2p-border-default)', cursor: 'pointer' }}>
              <input type="radio" name="reason" value={r} checked={reason === r} onChange={() => setReason(r)} style={{ accentColor: 'var(--p2p-buy)' }} />
              <span style={{ fontSize: 14, color: 'var(--p2p-text-primary)' }}>{r}</span>
            </label>
          ))}
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--p2p-text-primary)', marginBottom: 8 }}>Description</div>
          <textarea className="p2p-input" style={{ minHeight: 100, resize: 'none' }} placeholder="Describe the issue in detail..." value={description} onChange={e => setDescription(e.target.value)} />
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--p2p-text-primary)', marginBottom: 8 }}>Evidence (up to 5 images)</div>
          <div className="p2p-upload-grid">
            {evidence.map((img, i) => (
              <div key={i} className="p2p-upload-box" style={{ position: 'relative' }}>
                <img src={img} alt="evidence" />
                <button onClick={() => setEvidence(prev => prev.filter((_, idx) => idx !== i))} style={{ position: 'absolute', top: 4, right: 4, background: '#F6465D', border: 'none', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}><X size={12} color="#fff" /></button>
              </div>
            ))}
            {evidence.length < 5 && (
              <label className="p2p-upload-box">
                <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={handleFile} />
                <Upload size={24} color="var(--p2p-text-muted)" />
              </label>
            )}
          </div>
        </div>
        <button className="p2p-btn-yellow" disabled={loading} onClick={submit}>{loading ? 'Submitting...' : 'Submit Appeal'}</button>
      </div>
    </div>
  );
}
